module.exports = __webpack_public_path__ + "img/pic4.944ad272.png";